/**
 * @desc 列表
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(params: API.srm.supplierBoxBatch.pageList.Params, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierBoxBatch/pageList`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
